import { useState } from "react";
import { Reveal } from "@/components/Reveal";

const PRINT_QUOTES = [
  "Plain",
  "Heal Loud.",
  "Comeback Season.",
  "Recovery Era.",
  "Torn, Not Broken.",
  "Still Iconic.",
  "Injured, Not Invisible.",
];

const CATEGORIES = [
  { name: "Knee", img: "/renders/cat-knee.png", quote: "Heal Loud.", alt: "Athlete wearing a mocha LIGATEN knee brace printed Heal Loud" },
  { name: "Shoulder", img: "/renders/cat-shoulder.png", quote: "Recovery Era.", alt: "Athlete wearing a mocha LIGATEN shoulder brace printed Recovery Era" },
  { name: "Ankle", img: "/renders/cat-ankle.png", quote: "Torn, Not Broken.", alt: "Athlete wearing a mocha LIGATEN ankle brace printed Torn Not Broken" },
  { name: "Back", img: "/renders/cat-back.png", quote: "Still Iconic.", alt: "Athlete wearing a mocha LIGATEN back support printed Still Iconic" },
  { name: "Elbow", img: "/renders/cat-elbow.png", quote: "Injured, Not Invisible.", alt: "Athlete wearing a mocha LIGATEN elbow sleeve printed Injured Not Invisible" },
];

const CategoryTile = ({ cat, index }) => {
  const [selected, setSelected] = useState(cat.quote);
  const slug = cat.name.toLowerCase();
  return (
    <Reveal delay={index * 0.07}>
      <div
        data-testid={`category-tile-${slug}`}
        className="rounded-2xl overflow-hidden bg-[#EFE8DC] border border-[#2C241E]/10"
      >
        <div className="group relative aspect-[3/4] overflow-hidden">
          <img
            src={cat.img}
            alt={cat.alt}
            loading="lazy"
            className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
          />
        </div>
        <div className="p-4">
          <div className="flex items-baseline justify-between gap-2">
            <span className="font-display text-xl md:text-2xl text-[#2C241E]">{cat.name}</span>
            <span className="text-xs text-[#2C241E]/40">{String(index + 1).padStart(2, "0")}</span>
          </div>
          <p data-testid={`tile-quote-${slug}`} className="font-display italic text-sm text-[#2C241E]/60 mt-1">
            "{cat.quote}"
          </p>
          <p
            data-testid={`category-badge-${slug}`}
            className="text-[10px] font-medium tracking-[0.2em] uppercase text-[#2C241E]/45 mt-2"
          >
            Coming Soon
          </p>
          <p className="text-[10px] tracking-[0.2em] uppercase text-[#2C241E]/45 mt-4 mb-2">
            Print it with
          </p>
          <div className="flex flex-wrap gap-1.5">
            {PRINT_QUOTES.map((q, qi) => (
              <button
                key={q}
                data-testid={`quote-chip-${slug}-${qi}`}
                onClick={() => setSelected(q)}
                className={`text-[11px] font-medium rounded-full px-3 py-1.5 transition-[background-color,color,transform] duration-200 hover:-translate-y-0.5 ${
                  q === selected
                    ? "bg-[#2C241E] text-[#EFE8DC]"
                    : "bg-[#E5DFD5] text-[#2C241E]/70 hover:bg-[#B8AFA6]/60"
                }`}
              >
                {q}
              </button>
            ))}
          </div>
          <p data-testid={`selected-print-${slug}`} className="text-[11px] text-[#2C241E]/55 mt-2.5">
            Your print: {selected}
          </p>
        </div>
      </div>
    </Reveal>
  );
};

export const Categories = () => (
  <section data-testid="categories-section" className="max-w-7xl mx-auto px-6 md:px-10 pb-28 md:pb-40">
    <Reveal>
      <p className="text-xs font-medium tracking-[0.25em] uppercase text-[#2C241E]/50 mb-4">
        02 / Collection
      </p>
      <h2
        data-testid="categories-headline"
        className="font-display text-4xl md:text-6xl tracking-tighter text-[#2C241E] mb-6"
      >
        Shop by Category
      </h2>
      <p className="text-base md:text-lg leading-relaxed text-[#2C241E]/65 max-w-2xl mb-14">
        One signature shade — soft mocha. Every brace can be printed with your words — pick a
        quote below any product and it's stitched across the band.
      </p>
    </Reveal>
    <div className="grid grid-cols-1 min-[480px]:grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-4 md:gap-5">
      {CATEGORIES.map((cat, i) => (
        <CategoryTile key={cat.name} cat={cat} index={i} />
      ))}
    </div>
  </section>
);
